/** TCR-2492 — định dạng hiển thị chung của nhân viên AMIS: "{mã} · {tên}" (bỏ phần trống). */
export function formatAmisEmployee(e: { code?: string | null; name?: string | null }): string {
  return [e.code, e.name].filter((p): p is string => !!p && p.trim() !== '').join(' · ');
}
